import moment from 'moment';
import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { isNotValidNullUndefile } from '../control/Constant';
 
const CustomCalendar = ({ id, customClassName, label, placeholder, value, dod, onChange, type, compareDate, isError ,tabIndex, allowFutureDate, startAfter, futureLimit, showToday, setMaxMinDateFor,handleChangeOnFocusOut, callFocusOutFuncFor,personalDetails,spouseDetailsObj, isAMAStartDate, isDisabled, isAMADisabled, isAMAOfflineStartDate, isAMAOfflineDisabled, skipValidation,exWidth }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = allowFutureDate ? new Date(today.getFullYear(), today.getMonth(), today.getDate() + (futureLimit ?? 36500)) : today;
    const minDate = startAfter ? new Date(today.getFullYear(), today.getMonth(), today.getDate() + startAfter) : new Date(today.getFullYear() - 14, today.getMonth(), today.getDate());
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [showLabel, setShowLabel] = useState(false);
    const dropdownRef = useRef(null);
    const startingTabIndex = tabIndex ?? 0;
   
    const parseLocalDate = (value) => {
    if (!value) return null;
 
    if (value instanceof Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }
 
    if (typeof value === 'number') {
        const date = new Date(value);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
 
    if (typeof value === 'string') {
        const parts = value.split('T')[0].split('-');
        const [year, month, day] = parts.map(Number);
        return new Date(year, month - 1, day);
    }
 
    return null;
    };
 
    useEffect(() => {
        if (!isNotValidNullUndefile(value)) {
            setSelectedDate("");
            setShowLabel(true);
        } else {
 
            setSelectedDate(parseLocalDate(value));
            // const date = new Date(value);
            // const local = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
            // setSelectedDate(local);
            // const date = new Date(value);
            // const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
            // setSelectedDate(localDate);
            // setSelectedDate(new Date(value));
            setShowLabel(false);
        }
    }, [value,handleChangeOnFocusOut]);
 
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
 
 
    const validate = (date) => {
        const compareDateFormat = new Date(compareDate);
        let selectedDate = date;
        if (!isNotValidNullUndefile(compareDateFormat)) {
            return false;
        }
       if (selectedDate > maxDate && allowFutureDate == false) {
         return false;
        }
 
        return true;
    }
 
    const toggleCalendar = () => {
        if (isDisabled) return;
          if(selectedDate == "Invalid Date"){
            setSelectedDate("")
        }
        setShowCalendar(!showCalendar);
    };
 
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowCalendar(false);
        }
    };
 
    function isValidDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
 
        if (isNaN(date.getTime())) {
            return false;
        }
 
        // Check if the year is after 1700
        return year > 1700;
    }
 
    const inputDate = (e) =>{
      const date = e.target.value
      handleDateSelect(date)
      if(callFocusOutFuncFor == "FidBeneficiary" || callFocusOutFuncFor == "forChild"){
          handleChangeOnFocusOut(date)
      }
    }
 
    const handleDateSelect = (date) => {
        if(isValidDate(date)){
            const selectedDateOnly = moment(date).startOf('day');
            const todayOnly = moment(today).startOf('day');
 
            if ((isAMAStartDate && selectedDateOnly.isBefore(todayOnly)) || (isAMAOfflineDisabled && selectedDateOnly.isBefore(todayOnly))) {
                setSelectedDate('');
                setShowLabel(true);
                onChange('')
                return;
            } else {
                setSelectedDate(date);
                setShowLabel(false);
            }
            const isValid = validate(date);
            // let formatDate = moment(date).format("MM-DD-YYYY")
            let formatDate = moment(date).format("YYYY-MM-DD")
 
            if (!isValid) {
                setSelectedDate("");
                setShowLabel(true);
            } else {
                onChange(formatDate);
                setSelectedDate(date);
                setShowLabel(false);
            }
 
            setShowCalendar(false);
        }else{
            onChange(null);
            setSelectedDate("");
            setShowLabel(true);
        }
 
    };
 
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
 
    const getDaysInMonth = (year, month) => {
        return new Date(year, month + 1, 0).getDate();
    };
 
    const getFirstDayOfMonth = (year, month) => {
        return new Date(year, month, 1).getDay();
    };
 
    const CalendarComponent = () => {
        const [currentDate, setCurrentDate] = useState((isNotValidNullUndefile(selectedDate) || selectedDate == "Invalid Date") ? new Date(selectedDate) : new Date(setMaxMinDateFor == "PrimaryMember" ? minDate : today));
 
        const handlePrevMonth = () => {
            setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
        };
 
        const handleNextMonth = () => {
            setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
        };
 
        const handleDateClick = (day) => {
            const selected = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
                setSelectedDate(selected);
                handleDateSelect(selected);
        };
 
        const handleMonthChange = (event) => {
            const month = parseInt(event?.target?.value, 10);
            setCurrentDate(new Date(currentDate.getFullYear(), month));
        };
 
        const handleYearChange = (event) => {
            const year = parseInt(event?.target?.value, 10);
            setCurrentDate(new Date(year, currentDate.getMonth()));
        };
 
        const clearCalInput = () =>{
           setSelectedDate("")
           setShowCalendar(false);
           onChange('')
        }
 
        const showTodayDateInCalInput = () => {
            if(setMaxMinDateFor != "PrimaryMember"){
                const _curDate = new Date();
                _curDate.setHours(0, 0, 0, 0);
                handleDateSelect(_curDate);
                setShowCalendar(false)
            }
        }
 
        const handleEnterKeyPressDay = (e, day) => {
            if (e.key == 'Enter') {
                e.preventDefault();
                if (!isDisabled && !isAMADisabled) {
                    handleDateClick(day);
                }
            }
        };
 
        const renderDays = () => {
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const daysInMonth = getDaysInMonth(year, month);
            const firstDay = getFirstDayOfMonth(year, month);
            const days = [];
 
            // Adjust firstDay to start from Monday (0 = Sunday)
            const adjustedFirstDay = (firstDay === 0 ? 6 : firstDay - 1);
            const fiveYears = 5 * 365;
            const minAMADate = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate());
            const maxAMADate = new Date(today.getFullYear() + 5, today.getMonth(), today.getDate());
 
            // Add empty days for the previous month
            for (let i = 0; i < adjustedFirstDay; i++) {
                days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
            }
 
            // Add days of the current month
            for (let day = 1; day <= daysInMonth; day++) {
                const date = new Date(year, month, day);
                let selectedDateUpd = new Date(selectedDate)
                const isActive = selectedDateUpd?.getDate() == day && selectedDateUpd?.getMonth() == month && selectedDateUpd?.getFullYear() == year;
                const isDisabled = skipValidation ? false : (showToday && (date.getTime() == today.getTime())) ? false : type == 'validUser' ? date > minDate : (type == 'dateOfBirth' || type == "dateofDeath") ? date > today : startAfter ? (minDate > date || maxDate < date)  : date > maxDate ;
                const isAMADisabled = skipValidation ? false : isAMAStartDate && date < today && !(date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && day === today.getDate());
 
                const isAMAOfflineDisabled = skipValidation ? false : isAMAOfflineStartDate && (date < minAMADate || date > maxAMADate);
                days.push(
                    <div
                        key={day}
                        tabIndex={startingTabIndex + 4}
                        className={`calendar-day${isActive ? ' active' : ''}`}
                        onClick={() => ((!isDisabled && !isAMADisabled) || (!isDisabled && !isAMAOfflineDisabled)) && handleDateClick(day)}
                        onKeyDown={(e) => handleEnterKeyPressDay(e, day)}
                        style={{ color: (isDisabled || isAMADisabled || isAMAOfflineDisabled) ? 'darkgrey' : isActive ? '#fff' : 'inherit',backgroundColor:isActive ? '#720d21':'',textAlign:"center",padding:"8px",cursor:"pointer",borderRadius:"20px",transition:"background-color .3s",fontSize:"14px",lineHeight:"20px" }}
                    >
                        {day}
                    </div>
                );
            }
 
            return days;
        };
 
        const years = Array.from({ length: maxDate.getFullYear() - 1900 + 1 }, (_, i) => 1900 + i);
 
        const handleArrowKeyChangeBTn = (e) => {
            if (e.key == 'ArrowRight' || e.key =='ArrowLeft') {
                if (e.key == 'ArrowRight') {
                    handleNextMonth();
                } else if (e.key == 'ArrowLeft') {
                    handlePrevMonth();
                }
                e.preventDefault();
            }
        };
 
        const handleArrowKeyChange = (e, type) => {
            let newMonth = currentDate?.getMonth();
            let newYear = currentDate?.getFullYear();
 
            if (e.key == 'ArrowUp' || e.key == 'ArrowDown') {
                if (type == 'month') {
                    if (e.key == 'ArrowUp') {
                        newMonth = (newMonth + 1) % 12;
                    } else if (e.key == 'ArrowDown') {
                        newMonth = (newMonth - 1 + 12) % 12;
                    }
                } else if (type == 'year') {
                    if (e.key == 'ArrowUp') {
                        newYear += 1;
                    } else if (e.key == 'ArrowDown') {
                        newYear -= 1;
                    }
                }
 
                if (type == 'month') {
                    setCurrentDate(new Date(currentDate?.getFullYear(), newMonth));
                } else if (type == 'year') {
                    setCurrentDate(new Date(newYear, currentDate?.getMonth()));
                }
                e.preventDefault();
            }
        };
 
      return (
        <div id='custom-calendar' className="calendar-container mt-1" style={{
          display: 'flex',
          flexDirection: 'column', alignItems: 'center', padding: '10px', backgroundColor: '#fff', borderRadius: '10px',
          width: '300px', margin: 'auto', boxShadow: '0 4px 8px rgba(0, 0, 0, .1)',
          border: '1px solid #aeaeae'
        }}>
          <div className="calendar-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '8px' }}>
            <div className="calendar-header-selectors" style={{ display: "flex", gap: "8px" }}>
              <select className='tabFocus' tabIndex={startingTabIndex + 1} style={{ width: "106px", padding: ' 5px 0 !important', fontSize: '16px', border: '1px solid #ccc', borderRadius: '5px' }} value={currentDate.getMonth()} onChange={handleMonthChange} onKeyDown={(e) => handleArrowKeyChange(e, 'month')}>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i} value={i}>
                    {new Date(0, i).toLocaleString('default', { month: 'long' })}
                  </option>
                ))}
              </select>
              <select className='tabFocus' style={{ width: "106px", padding: ' 5px 0 !important', fontSize: '16px', border: '1px solid #ccc', borderRadius: '5px' }} tabIndex={startingTabIndex + 2} value={currentDate.getFullYear()} onChange={handleYearChange} onKeyDown={(e) => handleArrowKeyChange(e, 'year')}>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div className="d-flex gap-4 me-2">
              <button tabIndex={startingTabIndex + 3} className="me-2 tabFocus" onClick={handlePrevMonth} onKeyDown={handleArrowKeyChangeBTn} alt="prev" src="/New/icons/prevIcon.svg" >{'<'}</button>
              <button tabIndex={startingTabIndex + 4} className='tabFocus' onClick={handleNextMonth} onKeyDown={handleArrowKeyChangeBTn} alt="next" src="/New/icons/nextIcon.svg">{'>'}</button>
            </div>
          </div>
          <div className="calendar-grid" style={{
            display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gridGap: '5px', gap: '5px',
            width: '100%'
          }}>
            {daysOfWeek.map((day, index) => (
              <div key={index} className="calendar-day-of-week">
                {day}
              </div>
            ))}
            {renderDays()}
          </div>
          <div className='w-full flex justify-between'>
            <div className='mx-2' style={{ color: "grey", fontSize: "12px" }} onClick={() => clearCalInput()}>Clear</div>
            <div className='mx-2' style={{ color: "grey", fontSize: "12px" }} onClick={() => showTodayDateInCalInput()}>Today</div>
          </div>
        </div>
      );
    };
 
    let dateValueForInput = useMemo(() => {
        let valueOfDate = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : "";
        return valueOfDate;
    }, [selectedDate])

    const handleChange = (e) => {
        let value = e.target.value;
        setSelectedDate(value)
        setShowCalendar(false)
    }
 
    const handleEnterKey = (e) => {
        if (e.key == 'Enter') {
            toggleCalendar();
            e.preventDefault();
        } else if (e.key == 'Escape') {
            toggleCalendar();
            e.preventDefault();
        }
    };

    return (
        <div ref={dropdownRef} className={customClassName} onKeyDown={handleEnterKey} style={{width: exWidth ? exWidth : ""}} >
            <div  style={{position:"relative",display:"flex",justifyContent:"space-between",alignItems:"center",border:"1px solid #D1D5DB",borderRadius:"6px",backgroundColor:"#fff",fontSize:"16px",marginTop:"",cursor:"pointer",paddingLeft:"7px",paddingRight:"7px"}} className={`${isNotValidNullUndefile(isError) ? "dropdown-calender d-flex error-msg-calender" : "dropdown-calender d-flex"}`}>
                <input tabIndex={tabIndex}  id={id} className="datePickerInput w-100" type="date" value={dateValueForInput} placeholder={placeholder} onBlur={inputDate} onChange={handleChange} disabled={isDisabled} max="9999-12-31" style={{fontSize:'13px',borderBottom:'none',height:'32px',cursor:'pointer',appearance:'none',WebkitAppearance: 'none',MozAppearance:"textfield",background: 'none'}}/>
                <div className={`dropdown-icon ${showCalendar ? "dropdown-icon-bg" : ""}`} onClick={toggleCalendar}>
                    <img className="mt-0" src="/calendarImg.svg" alt="Calendar Icon" />
                </div>
                <div style={{display:showCalendar ? "block":'none',position:'absolute',backgroundColor:'#fff',boxShadow:' 0 8px 16px 0 rgba(0, 0, 0, .2)',zIndex:3,borderRadius:' 80px',top:' 100%',marginTop:'inherit'}}>
                    <CalendarComponent key={selectedDate}/>
                </div>
            </div>
            {isNotValidNullUndefile(isError) && <span className="err-msg-show">{isError}</span>}
        </div>
    );
};
 
export default CustomCalendar;